export default __webpack_public_path__ + "static/new-funnel-light-mode-49cd314792020998a715ae76aff458a2.mp4";